module.exports = __webpack_public_path__ + "static/shadow-5c882c952f00fc6092929b7d49be529c.png";